module.exports = __webpack_public_path__ + "img/layout-2.c43f6458.jpg";